import { render, staticRenderFns } from "./ConsoleSidebar.vue?vue&type=template&id=962f06ca&scoped=true&"
import script from "./ConsoleSidebar.vue?vue&type=script&lang=js&"
export * from "./ConsoleSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleSidebar.vue?vue&type=style&index=0&id=962f06ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962f06ca",
  null
  
)

export default component.exports